import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
    bgcolor: 'background.paper',
    border: '0px solid #000',
    boxShadow: 24,
    // p: 4,
    height: "max-content",
    textAlign: "center",
    borderRadius: "4px"
};

const ModalLayout = (props) => {
    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Stack sx={{ backgroundColor: props.title === "Accept" ? "green" : "red", p: 1 }} alignItems={"center"} display={"flex"} justifyContent={"center"}>
                    {props.title === "Accept" ? <CheckCircleIcon sx={{ color: "white", fontSize: '40px' }} />
                        : props.title === "Reject" ? <CancelIcon sx={{ color: "white", fontSize: '40px' }} /> : props.title === "Delete" ? <DeleteIcon sx={{ color: "white", fontSize: '40px' }} /> : "Please Modify Me"}
                </Stack>
                <Stack padding={4}>
                    {props.children}
                </Stack>
            </Box>
        </Modal>
    );
}

export default ModalLayout;
